var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-layout", { attrs: { row: "", wrap: "" } }, [
    _c(
      "div",
      { attrs: { align: "left" } },
      [
        _c("v-flex", { attrs: { md12: "" } }, [
          _c("h2", [_vm._t("default")], 2)
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }